import { array, boolean, number, object, string } from 'yup';

export const productSchema = object().shape({
  id: number().required(),
  code: string().required(),
  name: string().required(),
  sectionIds: array().ensure().of(number().required()).required(),
  picture: string().nullable(),
  altPicture: string().nullable(),
  volume: string().nullable(),
  isAvailable: boolean().required(),
  addToBasketId: number().nullable(),
  xmlId: string().required(),
  refillId: number().required().nullable(),
  priceInfo: object()
    .shape({
      price: number().required(),
      basePrice: number().nullable(),
      startsFrom: boolean().required(),
    })
    .required(),
  previewMode: boolean().optional(),
});
